module.exports = __webpack_public_path__ + "static/media/i22c.eba48df9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i22c.svg
// module id = 304
// module chunks = 12